import { Link } from "react-router-dom";
import { convertDate } from "utils/helpers";
import getGdnPackStatusLabelData from "utils/getGdnPackStatusLabelData";

const ActiveFastShipmentPacks = ({ rows }) => {
  return (
    <section className="dashboard m-b-20">
      <div className="dashboard__header">
        <h3 className="dashboard__title heading m-l-0">
          Aktywne paki szybkiej wysyłki{" "}
          <span style={{ fontWeight: 400, opacity: 0.85 }}>
            ({rows.length})
          </span>
        </h3>
      </div>
      <table className="table table-sm">
        <thead className="table__header">
          <tr>
            <th>ID paka</th>
            <th>Status</th>
            <th>Rozmiar kuwety</th>
            <th>Wózek</th>
            <th>Piker</th>
            <th>Paker</th>
            <th>Ilość zamówień</th>
            <th>Utworzono</th>
          </tr>
        </thead>
        <tbody className="table__body">
          {rows.length === 0 ? (
            <tr>
              <td colSpan={8}>Brak aktywnych paków szybkiej wysyłki</td>
            </tr>
          ) : (
            rows.map(
              ({
                id,
                status,
                cart_box_size,
                prepared_at,
                gdns_count,
                cart,
                picker,
                packer,
              }) => {
                const { status_text, color } = getGdnPackStatusLabelData({
                  status,
                });
                return (
                  <tr key={id}>
                    <td>
                      <Link className="link" to={`/packing/gdn_pack/${id}`}>
                        {id}
                      </Link>
                    </td>
                    <td>
                      <span
                        className={`label label--${color}`}
                        style={{ padding: "2px 6px" }}
                      >
                        <span className="text-10">{status_text}</span>
                      </span>
                    </td>
                    <td>{cart_box_size ?? "—"}</td>
                    <td>{cart?.name || "—"}</td>
                    <td>{picker?.full_name || "—"}</td>
                    <td>{packer?.full_name || "—"}</td>
                    <td>{gdns_count}</td>
                    <td>{convertDate({ value: prepared_at })}</td>
                  </tr>
                );
              },
            )
          )}
        </tbody>
      </table>
    </section>
  );
};

export default ActiveFastShipmentPacks;
